module.exports = __webpack_public_path__ + "static/recotex-square.e019c9c5.jpg";